//English en en_UK en_US
export const en = {
    //Error Validation
    "error-field":"Field",
    "error-required":"is required",
    "error-min-value":"cannot be less than",
    "error-max-value":"cannot be more than",
    "error-min-length":"cannot be shorter than",
    "error-max-length":"cannot be longer than",
    "error-min-duration":"cannot be before",
    "error-max-duration":"cannot be after",
    "error-characters":"characters",
    "error-mobile-number":"only accepts numbers and (+)",
    "error-characters":"cannot contain letters or special characters",
    "error-email":"has an invalid email address",
    "error-special-characters":"does not accept special characters",
    "error-no-space":"does not accept spaces",

    //Navigation Buttons
    "back":"Back",
    "next":"Next",

    //Load Indicators
    "preparing":"Preparing",
    "processing":"Processing",
    "deleting":"Deleting",
    "submitting":"Submitting",
};

//Chinese zh, zh_CN, zh_SG, zh_TW, zh_HK
export const zh = {
    "error-field":	"输入框"	,
    "error-required":	"必须填写"	,
    "error-min-value":	"不可少于"	,
    "error-max-value":	"不可超过"	,
    "error-min-length":	"不可短于"	,
    "error-max-length":	"不可多过"	,
    "error-min-duration":	"不可在之前"	,
    "error-max-duration":	"不可在之后"	,
    "error-characters":	"字符"	,
    "error-mobile-number":	"仅限数字和 （+）"	,
    "error-characters":	"不可包含字母或特殊字符"	,
    "error-email":	"电子邮件地址无效"	,
    "error-special-characters":	"不接受特殊字符"	,
    "error-no-space":	"不接受空格"	,

    "back":	"回返"	,
    "next":	"往下"	,

    "preparing":	"准备中"	,
    "processing":	"处理中"	,
    "deleting":	"删除中"	,
    "submitting":	"提交中"	,
};

//Bengali bn, bn_BD
export const bn = {
    "error-field":	"ক্ষেত্র"	,
    "error-required":	"দরকার"	,
    "error-min-value":	"চেয়ে কম হতে পারে না"	,
    "error-max-value":	"চেয়ে বেশি হতে পারে না"	,
    "error-min-length":	"চেয়ে খাটো হতে পারে না"	,
    "error-max-length":	"চেয়ে দীর্ঘতর হতে পারে না"	,
    "error-min-duration":	"আগে হতে পারবে না"	,
    "error-max-duration":	"পরে হতে পারে না"	,
    "error-characters":	"চরিত্র"	,
    "error-mobile-number":	"শুধুমাত্র সংখ্যা গ্রহণ করে এবং (+ +)"	,
    "error-characters":	"অক্ষর বা বিশেষ অক্ষর থাকতে পারে না"	,
    "error-email":	"একটি অবৈধ ইমেল ঠিকানা নেই"	,
    "error-special-characters":	"বিশেষ অক্ষর গ্রহণ করে না"	,
    "error-no-space":	"শূণ্যস্থান গ্রহণ করে না"	,

    "back":	"পেছনে"	,
    "next":	"পরবর্তী"	,

    "preparing":	"প্রস্তুতি"	,
    "processing":	"প্রসেসিং"	,
    "deleting":	"একবার মুছে"	,
    "submitting":	"জমা দেওয়া হচ্ছে"	,
};

//Tamil ta, ta_IN
export const ta = {
    "error-field":	"இடம்"	,
    "error-required":	"தேவை"	,
    "error-min-value":	"விட குறைவாக இருக்க கூடாது"	,
    "error-max-value":	"விட அதிகமாக இருக்க கூடாது"	,
    "error-min-length":	"விட குறைவாக இருக்க கூடாது"	,
    "error-max-length":	"விட நீண்டு இருக்க கூடாது"	,
    "error-min-duration":	"முன்பு இருக்க கூடாது"	,
    "error-max-duration":	"பிறகு இருக்க கூடாது"	,
    "error-characters":	"குறியீடுகள்"	,
    "error-mobile-number":	"எண்களை மற்றும் (+) மட்டுமே ஏற்றுக்கொள்கிறது" 	,
    "error-characters":	"எழுத்துக்கள் அல்லது சிறப்பு எழுத்துக்கள் இருக்கக்கூடாது"	,
    "error-email":	"தவறான மின்னஞ்சல் முகவரி உள்ளது"	,
    "error-special-characters":	"சிறப்பு குறியீடுகள் ஏற்காது"	,
    "error-no-space":	"இடைவெளிகளை ஏற்காது"	,

    "back":	"மீண்டும்",//"பின்பு செல்லவும்"	,
    "next":	"அடுத்தது"	,

    "preparing":	"தயாராக்கப்படுகிறது"	,
    "processing":	"செயலாக்கப்படுகிறது"	,
    "deleting":	"அழிக்கிறது"	,
    "submitting":	"சமர்ப்பிக்கப்படுகிறது"	,
};
